import { pipe } from 'rxjs';
import { selectLastTravel } from './last-travel.selector';
import { prop } from 'ramda';

export const selectIsArrivedViaWormhole = pipe(
  selectLastTravel,
  prop('viaWormhole'),
);
